import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

const application = Application.start()
window.Stimulus = application
const context = require.context("controllers", true, /-controller\.js$/)
application.load(definitionsFromContext(context))
